import {json, texture} from "p3";
import common from "../../common";
import GameScene from "../../scenes/GameScene";
import settings from "../../settings";
import {iswebfont, locale, resizeLabelToFitText} from "../../utils";

export default class SatchelTab extends PIXI.Container {

    constructor(inventory) {

        super();

        this._inventory = inventory;

        this._items = [];

        this._itemHolder;

        this._scrolling = false;
        this._scrollPos = 0;
        this._scrollMax = 0;
        this._scrollDistance = 0;

        this.gridWidth = 5;
        this.gridHeight = 4;

    }

    fill(panel)
    {
        this._itemHolder = new PIXI.Container();
        this.addChild(this._itemHolder);

        const boxSize = 124;

        const itemData = json("inventory").slice();

        let c = 0;
        for(let i in itemData){
            //itemData[i].amount = c > 2 ? (10 + Math.floor(Math.random() * 10)) : 0;//this._inventory.itemQuantity(itemData[i].id);

            if (itemData[i].phase > settings.PHASE) {
                continue;
            }
     
            itemData[i].amount = this._inventory.itemQuantity(itemData[i].id);

            c++;
        }

        itemData.sort((a, b) => {
            return b.amount - a.amount;
        });
        
        const areaWidth = panel.width * 0.89;
        const areaHeight = panel.height * 0.90;
        const margin = (areaWidth - (boxSize * this.gridWidth)) / (this.gridWidth-1); 

        const colorMatrix = new PIXI.filters.ColorMatrixFilter();
        colorMatrix.desaturate();

        let currentX = 0;
        let currentY = 0;

        for(let i = 0; i < itemData.length; i++){
            var item = new PIXI.Sprite(texture('inventory_slot'));

            if (itemData[i].phase > settings.PHASE) {
                continue;
            }
            
            this._items.push(item);
            this._itemHolder.addChild(item);
            item.width = item.height = boxSize;
            item.x = -(areaWidth/2) + (currentX * (boxSize)) + (currentX * margin);
            item.y = -(areaHeight/2) + (currentY * (boxSize)) + (currentY * margin);
            currentX ++;
            if(currentX >= this.gridWidth){
                currentY ++;
                currentX = 0;
            }
            item.icon = new PIXI.Sprite(texture(itemData[i].thumbnail));
            item.icon.anchor.set(0.5);
            //item.icon.scale.set(0.5);
            item.icon.x = boxSize/2;
            item.icon.y = boxSize/2;
            item.addChild(item.icon);
            //console.log(item.icon);

            const wScale = item.width / item.icon.width;
            const hScale = item.height / item.icon.height;

			//if(wScale != null && hScale != null) {
				item.icon.scale.set(Math.min(wScale, hScale));
			//}

            if (itemData[i].amount == 0) {
                item.icon.alpha = 0.5;
                item.icon.filters = [colorMatrix];
                item.texture = texture('inventory_slot_off');
            }
            else {
                item.amountTag = new PIXI.Sprite(texture("inventory_slot_amount"));
                item.addChild(item.amountTag);

                const tagSize = boxSize*0.35;

                if (!iswebfont()) {
                    item.amountLabel = new PIXI.BitmapText(String(itemData[i].amount), {
                        fontName: "Alghera Pro",
                        fontSize: 30,
                        align: "left",
                        tint: 0xFFFFFF
                    });
                } else {
                    item.amountLabel = new PIXI.Text(String(itemData[i].amount), {
                        fontFamily: "FredFredBurger",
                        fontSize: 30,
                        align: "left",
                        fill: 0xFFFFFF
                    });
                }
                item.amountLabel.position.set(boxSize - (tagSize*0.5),(tagSize*0.5));
                item.amountLabel.anchor.set(0.5);
                item.addChild(item.amountLabel);
        
                resizeLabelToFitText(item.amountLabel, tagSize*0.7);
            }
        }

        this._scrollMax = Math.max(0, currentY - this.gridHeight);
        this._scrollDistance = boxSize + margin;

        this._mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.addChild(this._mask);
        this._mask.anchor.set(0.5);
        this._mask.width = areaWidth;
        this._mask.height = areaHeight;
        this._itemHolder.mask = this._mask;
    }

    scroll(direction)
    {
        if(this._scrolling)
            return;

        if(direction > 0 && !this.checkScrollDown()){
            return;
        }
        if(direction < 0 && !this.checkScrollUp()){
            return;
        }

        this._scrolling = true;

        this._scrollPos += direction * this.gridHeight;

        for(let i = 0; i < this._items.length; i++)
        {
            GameScene.active.addTween(gsap.to(this._items[i], 0.5, {y:this._items[i].y+(this._scrollDistance*-(direction*this.gridHeight)), ease:Expo.easeOut, onComplete:() => {
                if(i == 0)
                    this._scrolling = false;
            }}));
        }
    }

    checkScrollUp() {
        return this._scrollPos > 0;
    }

    checkScrollDown() {
        return this._scrollPos < this._scrollMax;
    }

    get items() {
        return this._items;
    }

    get areaMask() {
        return this._mask;
    }
}